const isHourFormat12 = () => {
  const currentDate = new Date();
  const currentDateTimeString = currentDate.toLocaleTimeString([]);
  const hours12 = currentDateTimeString.match(/am|pm/i) || currentDate.toString().match(/am|pm/i);

  return hours12;
};

export default isHourFormat12;
